<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.recipes') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <div
        v-if="ready"
        class="col-md-12 no-padding">
        <table
          id="dataTable"
          class="table table-bordered"
          style="width: 100%;">
          <thead>
            <tr>
              <th>{{ $t('message.recipename') }}</th>
              <th
                class="text-center"
                style="width: 150px;">{{ $t('message.assignitems') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in recipes"
              :key="index">
              <td>
                <router-link
                  :to="{
                    name: 'RecipeEdit',
                    query: {
                      id: item._id,
                      name: item.name,
                    }
                }">
                  {{ item.name }}
                </router-link>
              </td>
              <td
                class="text-center"
                style="width: 150px;">
                {{ item.assign_skus.length }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  data () {
    return {
      ready: false,
    }
  },
  computed: mapGetters({
    recipes: 'getRecipes',
  }),
  mixins: [userPermissionMixin],
  watch: {
    ready () {
      this.showFinish(this.$Progress)
      let option = this.dataTableOption()
      setTimeout(() => { $('#dataTable').DataTable(option) }, 1)
    },
  },
  async created () {
    await this.$store.dispatch('getRecipes')
    this.ready = true
  },
  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 6,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 4,
      submenuAtIdx: 0,
    })
  },
  destroyed () {
    this.leavePage(this.$Progress)
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/items/recipe/All.vue